<p-panel styleClass="h-full">
    <ng-template pTemplate="header">
        <div><h4>Providers</h4></div>
    </ng-template>


    <div *ngIf="encounter" class="flex w-full flex-column h-full">
        <div *ngIf="!editRequested && encounter.requestedProvider" class="flex card w-full align-items-center pt-2">
            <p-card class="appointmentCard" header="Requested">
                <div class="flex align-items-center w-full flex-row">
                    <div *ngIf="encounter.requestedProvider" class="flex flex-column">
                        <div>{{encounter.requestedProvider.facility.name}}</div>
                        <div class="flex flex-column text-xs pt-2">
                            <div>{{encounter.requestedProvider.location.street1}}</div>
                            <div *ngIf="encounter.requestedProvider.location.street2">{{encounter.requestedProvider.location.street2}}</div>
                            <div>{{encounter.requestedProvider.location.city}}, {{encounter.requestedProvider.location.state}} {{encounter.requestedProvider.location.zipCode}}</div>
                        </div>
                    </div>
                    <div *ngIf="!locked" class="flex flex-column">
                        <p-button *ngIf="encounter.requestedProvider" icon="pi pi-wrench" text (onClick)="editRequested=true"></p-button>
                        <!-- <p-button *ngIf="allowProposedEdit && encounter.proposedProvider" icon="pi pi-trash" text (onClick)="deleteProposedProvider($event)"></p-button> -->
                        <p-button *ngIf="!encounter.requestedProvider" icon="pi pi-plus" text (onClick)="editRequested=true"></p-button>

                    </div>
                </div>
                <div class="flex align-items-center flex-row w-full mt-4">
                    
                    <div class="flex w-6 pl-2 justify-content-end">
                        <p-button *ngIf="!locked && requestedCostEdited" icon="pi pi-save" text  (onClick)="updateEstimatedCosts()"></p-button>
                    </div>
                    <div class="flex align-items-end w-6 justify-content-end">
                        <p-floatLabel>
                            <p-inputNumber id="requestedCost"  [(ngModel)]="encounter.estimatedRequestedCost" mode="currency" currency="USD" locale="en-US"  [disabled]="locked" (onBlur)="requestedCostEdited = true"/>
                            <label for="requestedCost">Cost</label>
                        </p-floatLabel>                    
                    </div>
                </div>
            </p-card>
        </div>
        <div *ngIf="editRequested" class="flex card w-full align-items-center">
            <p-card class="appointmentCard">
                <div class="flex flex-row">
                    <div class="flex align-items-center w-full flex-row">
                        <app-facility-location-search  [(facility)]="encounter.requestedProvider"  (facilityChange)="requestedProviderSelected($event); editRequested=false" placeholder="Select Requested Provider"></app-facility-location-search>
                        <p-button icon="pi pi-times" text (onClick)="editRequested=false"></p-button>
                    </div>
                </div>
            </p-card>
        </div>
        <div *ngIf="!editProposed && encounter.proposedProvider" class="flex card w-full align-items-center" >
            <p-card class="appointmentCard" header="Proposed">
                <div class="flex align-items-center w-full flex-row">
                    <div *ngIf="encounter.proposedProvider" class="flex flex-column">
                        <div>{{encounter.proposedProvider.facility.name}}</div>
                        <div class="flex flex-column text-xs pt-2">
                            <div>{{encounter.proposedProvider.location.street1}}</div>
                            <div *ngIf="encounter.proposedProvider.location.street2">{{encounter.proposedProvider.location.street2}}</div>
                            <div>{{encounter.proposedProvider.location.city}}, {{encounter.proposedProvider.location.state}} {{encounter.proposedProvider.location.zipCode}}</div>
                        </div>
                    </div>
                    <div *ngIf="!locked" class="flex flex-column">
                        <p-button *ngIf="allowProposedEdit && encounter.proposedProvider" icon="pi pi-wrench" text (onClick)="editProposed=true"></p-button>
                        <!-- <p-button *ngIf="allowProposedEdit && encounter.proposedProvider" icon="pi pi-trash" text (onClick)="deleteProposedProvider($event)"></p-button> -->
                        <p-button *ngIf="allowProposedEdit && !encounter.proposedProvider" icon="pi pi-plus" text (onClick)="editProposed=true"></p-button>

                    </div>
                </div>
                <div class="flex align-items-center flex-row w-full mt-4">

                    <div class="flex w-6 pl-2 justify-content-end">
                        <p-button *ngIf="!locked && proposedCostEdited" icon="pi pi-save" text  (onClick)="updateEstimatedCosts()"></p-button>
                    </div>
                    <div class="flex align-items-end w-6">
                        <p-floatLabel>
                            <p-inputNumber id="proposedCost"  [(ngModel)]="encounter.estimatedProposedCost" mode="currency" currency="USD" locale="en-US"  [disabled]="locked" (onBlur)="proposedCostEdited = true"/>
                            <label for="proposeCost">Cost</label>
                        </p-floatLabel>                    
                    </div>
                </div>
            </p-card>
        </div>
        <div *ngIf="editProposed" class="flex card w-full align-items-center">
            <p-card class="appointmentCard">
                <div class="flex flex-row">
                    <div class="flex align-items-center w-full flex-row">
                        <app-facility-location-search  [(facility)]="encounter.proposedProvider"  (facilityChange)="proposedProviderSelected($event); editProposed=false" placeholder="Select Proposed Provider"></app-facility-location-search>
                        <p-button icon="pi pi-times" text (onClick)="editProposed=false"></p-button>
                    </div>
                </div>
            </p-card>
        </div>
        <div *ngIf="encounter.confirmedProvider" class="flex card w-full align-items-center pt-2">
            <p-card class="appointmentCard" header="Confirmed">
                <div class="flex align-items-center w-full flex-row">
                    <div *ngIf="encounter.confirmedProvider" class="flex flex-column">
                        <div>{{encounter.confirmedProvider.facility.name}}</div>
                        <div class="flex flex-column text-xs pt-2">
                            <div>{{encounter.confirmedProvider.location.street1}}</div>
                            <div *ngIf="encounter.confirmedProvider.location.street2">{{encounter.confirmedProvider.location.street2}}</div>
                            <div>{{encounter.confirmedProvider.location.city}}, {{encounter.confirmedProvider.location.state}} {{encounter.confirmedProvider.location.zipCode}}</div>
                        </div>
                    </div>
                </div>
            </p-card>
        </div>
        <!-- <app-facility-location-search [(facility)]="encounter.confirmedProvider" (facilityChange)="confirmedProviderSelected($event)" placeholder="Select Confirmed Provider" ></app-facility-location-search> -->
    </div>



</p-panel>

